import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const reminderTypes = async () => axios.get(Routes.REMINDER_TYPES);

export const useReminderTypes = () =>
  useQuery({
    queryKey: [Keys.REMINDER_TYPES_QRY],
    queryFn: reminderTypes,
  });
